<template>
  <div class="withdraw-mode-form">
    <div :class="exchangeClass">
      <div :class="isPc ? 'colu-12' : 'colu colu-12'">
        <label class="colu-12 for-label" :class="{ 'exchange-pc-label': isPc }">
          {{ $t('Bao.withdrawal_source_wallet') }}
        </label>

        <div :class="isPc ? 'row-frame' : 'exchange-input-row'">
          <div :class="isPc ? 'colu colu-9 exchange-amount-wrap' : 'exchange-input-col exchange-amount-wrap'">
            <input
              :id="'exchange-amount-' + viewType"
              class="for-input inpType"
              type="text"
              :value="page.postForm.amount"
              autocomplete="off"
              @input="page.onExchangeAmountInput($event)"
            >
            <span class="exchange-max-btn" @click="onMaxClick">MAX</span>
          </div>

          <div :class="isPc ? 'colu colu-3' : 'exchange-select-col'">
            <div :id="'exchange-from-' + viewType + '-wrap'" class="custom-select-wrap" data-value="USDT">
              <button class="cs-btn" @click.prevent="page.isOpenCurrency = !page.isOpenCurrency">
                <template v-if="page.selectedCoin">
                  <img :src="$getThemeImagePath('crypto-' + page.selectedCoin.symbol.toLowerCase() + '.svg')" style="width:24px; height:24px; border-radius:50%;" alt="">
                  {{ page.selectedCoin.symbol }}
                </template>
                <template v-else-if="page.selectedWallet">
                  <img :src="page.selectedWallet.key === 'bonus' ? $getThemeImagePath('default-crypto.svg') : page.getWalletImagePath(page.selectedWallet)" alt="">
                  {{ page.mainCurrencyLabel }}
                </template>
              </button>
              <ul class="cs-list" :class="{ active: page.isOpenCurrency }">
                <li v-if="page.mainWallet && !page.isTheme('theme_purple')" @click="page.selectNonCryptoWallet(page.mainWallet)">
                  <img :src="page.mainWallet.key === 'bonus' ? $getThemeImagePath('default-crypto.svg') : page.getWalletImagePath(page.mainWallet)" style="width:20px; height:20px; border-radius:50%;">
                  {{ page.mainCurrencyLabel }}
                </li>
                <li
                  v-for="coin in page.coinList"
                  :key="coin.coinId"
                  @click="page.onSelectCrypto(coin)"
                >
                  <img :src="$getThemeImagePath('crypto-' + coin.symbol.toLowerCase() + '.svg')" alt="" style="width:20px; height:20px; border-radius:50%;">
                  {{ coin.symbol }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div v-if="page.hasExchangePaymentFee" class="colu colu-12">
        <span :id="'exchange-fee-' + viewType" class="exchange-fee">{{ $t('Bao.payment_fee') }} {{ page.exchangePaymentFee }} %</span>
      </div>

      <div v-if="!page.selectedCoin" :id="'exchange-wallet-row-' + viewType" class="colu colu-12 exchange-wallet-row">
        <label class="colu-12 for-label" :class="{ 'exchange-pc-label': isPc }">{{ $t('Bao.withdraw_select_wallet') }}</label>
        <div :id="'exchange-wallet-' + viewType + '-wrap'" class="custom-select-wrap">
          <button class="cs-btn" @click.prevent="page.isOpenWallet = !page.isOpenWallet">
            {{ page.getWalletName(page.selectedWalletKey) }}
          </button>
          <ul class="cs-list" :class="{ active: page.isOpenWallet }">
            <li
              v-for="wallet in page.nonCryptoWallets"
              :key="wallet.key"
              @click="page.selectNonCryptoWallet(wallet)"
            >
              {{ page.getWalletName(wallet.key) }}
            </li>
          </ul>
        </div>
      </div>

      <div :class="isPc ? 'colu colu-12 withdraw-detail-frame' : 'colu colu-12'">
        <template v-if="isPc">
          <div class="detailList">
            <b class="wDtitle">{{ $t('Bao.withdraw_limit') }}</b>
            <span :id="limitId" class="wDamount">{{ page.withdrawalLimit }}</span>
          </div>
          <div class="detailList">
            <b class="wDtitle">{{ $t('Bao.withdraw_exchangeable_amount') }}</b>
            <span :id="'exchange-available-amount-' + viewType" class="wDamount">
              {{ page.exchangeAvailableAmount }} {{ page.selectedCoin ? page.selectedCoin.symbol : page.mainCurrencyLabel }}
            </span>
          </div>
        </template>
        <div v-else class="withdraw-detail-frame">
          <div class="detailList">
            <b class="wDtitle">{{ $t('Bao.withdraw_limit') }}</b>
            <span :id="limitId" class="wDamount">{{ page.withdrawalLimit }}</span>
          </div>
          <div class="detailList">
            <b class="wDtitle">{{ $t('Bao.withdraw_exchangeable_amount') }}</b>
            <span :id="'exchange-available-amount-' + viewType" class="wDamount">
              {{ page.exchangeAvailableAmount }} {{ page.selectedCoin ? page.selectedCoin.symbol : page.mainCurrencyLabel }}
            </span>
          </div>
        </div>
      </div>

      <div class="colu colu-12" :style="swapWrapStyle">
        <button
          id="exchange-swap-btn-pc"
          type="button"
          class="exchange-swap-btn"
          :style="{ display: 'block', margin: '0px auto', cursor: page.canSwapExchangeCoins ? 'pointer' : 'default' }"
          @click="page.swapExchangeCoins()"
        >
          <svg v-if="!page.canSwapExchangeCoins" viewBox="0 0 48 48" fill="none" width="44" height="44"><circle class="swap-circle" cx="24" cy="24" r="22" stroke-width="2.5" fill="var(--bg-box-subtle, #fff)" /><line class="swap-arrow-down" x1="24" y1="14" x2="24" y2="34" stroke-width="2.8" stroke-linecap="round" /><polyline class="swap-arrow-down" points="18,28 24,34 30,28" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" fill="none" /></svg>
          <svg v-else viewBox="0 0 48 48" fill="none" width="44" height="44"><circle class="swap-circle" cx="24" cy="24" r="22" stroke-width="2.5" fill="var(--bg-box-subtle, #fff)" /><line class="swap-arrow-down" x1="18" y1="14" x2="18" y2="34" stroke-width="2.8" stroke-linecap="round" /><polyline class="swap-arrow-down" points="14,30 18,34 22,30" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" fill="none" /><line class="swap-arrow-up" x1="30" y1="34" x2="30" y2="14" stroke-width="2.8" stroke-linecap="round" /><polyline class="swap-arrow-up" points="26,18 30,14 34,18" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" fill="none" /></svg>
        </button>
      </div>

      <div :class="isPc ? 'colu-12' : 'colu colu-12'">
        <label class="colu-12 for-label" :class="{ 'exchange-pc-label': isPc }">{{ $t('Bao.withdraw_transfer_to_wallet') }}</label>
        <div :class="isPc ? 'row-frame' : 'exchange-input-row'">
          <div :class="isPc ? 'colu colu-9' : 'exchange-input-col'">
            <input :id="'exchange-result-' + viewType" class="for-input inpType exchange-result-input" type="text" :value="page.exchangeResultAmount" readonly>
          </div>
          <div :class="isPc ? 'colu colu-3' : 'exchange-select-col'">
            <div :id="'exchange-to-' + viewType + '-wrap'" class="custom-select-wrap" data-value="">
              <button class="cs-btn" type="button" style="color:var(--text-secondary);" @click.prevent="page.isOpenCrypto = !page.isOpenCrypto">
                <template v-if="page.selectedExchangeTargetCoin">
                  <img :src="$getThemeImagePath('crypto-' + page.selectedExchangeTargetCoin.symbol.toLowerCase() + '.svg')" alt="" style="width:20px; height:20px; border-radius:50%;">
                  {{ page.selectedExchangeTargetCoin.symbol }}
                </template>
                <template v-else>
                  {{ $t('Bao.withdraw_select') }}
                </template>
              </button>
              <ul class="cs-list" :class="{ active: page.isOpenCrypto }">
                <li
                  v-for="coin in page.exchangeTargetCoinList"
                  :key="coin.coinId"
                  @click.stop="page.selectExchangeTargetCrypto(coin)"
                >
                  <img :src="$getThemeImagePath('crypto-' + coin.symbol.toLowerCase() + '.svg')" alt="" style="width:20px; height:20px; border-radius:50%;">
                  {{ coin.symbol }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :id="isPc ? 'pc-detail-frame' : undefined" :class="detailFrameClass">
      <template v-if="isPc">
        <div class="detailList">
          <b :id="'withdraw-available-label-' + viewType" class="wDtitle">{{ $t('Bao.withdraw_actual_transfer_amount') }}</b>
          <span :id="'withdraw-available-amount-' + viewType" class="wDamount">
            {{ page.exchangeAvailableAmount }} {{ page.exchangeSourceCurrency }}
          </span>
        </div>
        <div :id="'exchange-total-row-' + viewType" class="detailList">
          <b class="wDtitle">{{ $t('Bao.withdraw_amount_received') }}</b>
          <span :id="'exchange-total-amount-' + viewType" class="wDamount">{{ page.exchangeReceiveAmountText }}</span>
        </div>
        <div :id="'exchange-rate-row-' + viewType" class="detailList">
          <b class="wDtitle">{{ $t('Bao.withdraw_exchange_rate') }}</b>
          <span :id="'exchange-rate-' + viewType" class="wDamount">{{ page.exchangeRateText }}</span>
        </div>
      </template>
      <div v-else class="withdraw-detail-frame">
        <div class="detailList">
          <b :id="'withdraw-available-label-' + viewType" class="wDtitle">{{ $t('Bao.withdraw_actual_transfer_amount') }}</b>
          <span :id="'withdraw-available-amount-' + viewType" class="wDamount">
            {{ page.exchangeAvailableAmount }} {{ page.exchangeSourceCurrency }}
          </span>
        </div>
        <div :id="'exchange-total-row-' + viewType" class="detailList">
          <b class="wDtitle">{{ $t('Bao.withdraw_amount_received') }}</b>
          <span :id="'exchange-total-amount-' + viewType" class="wDamount">{{ page.exchangeReceiveAmountText }}</span>
        </div>
        <div :id="'exchange-rate-row-' + viewType" class="detailList" :style="isPc ? null : { position: 'relative' }">
          <b class="wDtitle">{{ $t('Bao.withdraw_exchange_rate') }}</b>
          <span :id="'exchange-rate-' + viewType" class="wDamount">{{ page.exchangeRateText }}</span>
        </div>
      </div>
    </div>

    <hr class="withdraw-pw-divider">
  </div>
</template>

<script>
export default {
  name: 'WithdrawCryptoExchangeFields',
  props: {
    page: {
      type: Object,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  computed: {
    isPc() {
      return this.viewType === 'pc'
    },
    exchangeClass() {
      return this.isPc ? 'colu colu-12 withdraw-type-exchange-pc' : 'withdraw-type-section withdraw-type-exchange'
    },
    detailFrameClass() {
      return this.isPc ? 'colu colu-12 withdraw-detail-frame' : 'colu colu-12'
    },
    limitId() {
      return this.isPc ? 'exchange-wager-pc-val' : 'exchange-wager-inline-val'
    },
    swapWrapStyle() {
      return {
        textAlign: 'center',
        margin: this.isPc ? '8px 0' : '4px 0'
      }
    }
  },
  methods: {
    onMaxClick() {
      if (this.viewType === 'mb') this.page.setExchangeMaxAmount()
    }
  }
}
</script>

<style scoped>
.withdraw-mode-form {
  display: contents;
}

.withdraw-mode-form > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}
</style>
